import styled from "styled-components";

const AppStyle = styled.div<any>`
  height: 100vh;
  padding: ${(props) =>
    props.isLogged
      ? props.isPermanent
        ? "24px 24px 24px 284px"
        : "24px 24px 24px 92px"
      : "0px"};
`;

export default AppStyle;
